import { Col, InputNumber, Row, Table } from "antd";

import { Link } from "react-router-dom";

const SaleProductListCard = ({ list, updateReturn, returnOnChange }) => {
  const columns = [
    {
      title: "ID",
      dataIndex: "product_id",
      key: "product_id",
    },
    {
      title: "Variety",
      dataIndex: "product",
      key: "product.name",
      render: (product) => (
        <Link to={`/product/${product.id}`}>{product.name}</Link>
      ),
    },
    {
      title: "Pack Rate",
      dataIndex: "pack_rate",
      key: "pack_rate",
    },
    {
      title: "Length",
      dataIndex: "length",
      key: "length",
    },
    {
      title: "Box No",
      dataIndex: "boxes",
      key: "boxes",
    },
    {
      title: "Stem Count",
      dataIndex: "product_quantity",
      key: "product_quantity",
    },
    {
      title: "Unit Price",
      dataIndex: "product_sale_price",
      key: "product_sale_price",
    },
    {
      title: "Total Price ",
      key: "Total Price ",
      dataIndex: "",
      render: ({
        product_quantity,
        product_sale_price,
        remain_quantity,
        return_quantity,
      }) => {
        if (return_quantity) {
          return (remain_quantity * product_sale_price).toFixed(2);
        } else {
          return (product_sale_price * product_quantity).toFixed(2);
        }
      },
    },
  ];

  if (updateReturn) {
    // columns.splice(3, 0, {
    //   title: "Remain Quantity",
    //   dataIndex: "remain_quantity",
    //   key: "remain_quantity",
    //   width: "120px",
    // });
    columns.splice(4, 0, {
      title: "Return Quantity",
      dataIndex: "return_quantity",
      key: "return_quantity",
      width: "150px",
      render: (
        value,
        { product_id, product_quantity, product_sale_price: price }
      ) => {
        return (
          <div>
            <InputNumber
              onChange={(value) =>
                returnOnChange({ id: product_id, value, price })
              }
              style={{ width: "120px" }}
              placeholder="Return Qty"
              max={product_quantity}
              min={0}
              value={value}
            />
          </div>
        );
      },
    });
  }

  const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

  return (
    <Row>
      <Col span={24} className="mt-2">
        <div
          className="header-solid h-full m-2"
          style={{ paddingTop: "0" }}
        >
          <h6 className="font-semibold m-0 text-center">
            sale Product Information
          </h6>
          <div className="col-info">
            <Table
              scroll={{ x: true }}
              loading={!list}
              columns={columns}
              dataSource={list ? addKeys(list) : []}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default SaleProductListCard;
